import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';

import { GeoLocationService, JobPositionsService, JobsService, SharedModule } from '@app/shared';
import { ApplyNowFormComponent } from './apply-now-form.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [ApplyNowFormComponent],
  imports: [
    CheckboxModule,
    CommonModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    NgxMaskModule.forRoot(maskConfig),
    ReactiveFormsModule,
    RouterModule,
    SelectButtonModule,
    SharedModule,
  ],
  exports: [ApplyNowFormComponent],
  providers: [GeoLocationService, JobPositionsService, JobsService],
})
export class ApplyNowFormModule {}
